import type { ExploreCategory } from "@/lib/explore";

export function ExploreIcon({ name, size = 20 }: { name: "arrow" | "search" | "bookmark" | "spark" | "close" | ExploreCategory; size?: number }) {
  const paths = {
    arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
    search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
    bookmark: <path d="M6 3h12v18l-6-4-6 4V3Z" />,
    spark: <><path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z" /><path d="M20 2v4m-2-2h4" /></>,
    close: <path d="m6 6 12 12M6 18 18 6" />,
    Variations: <><path d="M5 4v16m0-8h7l7-7m-7 7 7 7" /><circle cx="19" cy="5" r="2" /><circle cx="19" cy="19" r="2" /></>,
    Puzzles: <><path d="M9 4H4v6a3 3 0 1 1 0 6v4h6a3 3 0 1 0 6 0h4v-6a3 3 0 1 1 0-6V4h-5a3 3 0 1 0-6 0Z" /></>,
    Lessons: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="m10 8 6 4-6 4V8Z" /></>,
    Glossary: <><path d="M5 3h14v18H5zM8 7h8M8 11h6M8 15h4" /></>,
    Openings: <><path d="M5 20h14M7 17h10l-2-4V9H9v4l-2 4ZM9 9h6M12 3v3M9 6h6" /><circle cx="12" cy="7" r="2" /></>,
    Games: <><rect x="4" y="4" width="16" height="16" rx="1" /><path d="M4 9h16M4 15h16M9 4v16m6-16v16" /></>,
    Endgames: <path d="M5 21V4m0 0c5-5 9 5 15 0v10c-6 5-10-5-15 0" />,
    Champions: <path d="m3 6 4 4 5-6 5 6 4-4-2 12H5L3 6Zm3 15h12" />,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
